<script setup lang="ts">
import { BlockCollapsableMenu, FaqsItem } from '~/lib/services/content/content.blocks.dtos'

const activeItem = shallowRef<FaqsItem>()

const setActiveItem = (item: FaqsItem) => {
  activeItem.value = item
}

const props = defineProps<{ block: BlockCollapsableMenu }>()
</script>
<template>
  <section class="my-10 flex w-full justify-evenly p-10">
    <div class="flex w-2/6 flex-col gap-5">
      <header>
        <h3 class="text-4xl font-bold">{{ props.block.title }}</h3>
      </header>
      <ul>
        <li
          v-for="faqsItem in props.block.faqsItem"
          :key="faqsItem.id"
          class="my-4 flex"
          @click="setActiveItem(faqsItem)"
        >
          <MenuCard image-card="/images/icons/toast/info.svg" :text="faqsItem.title" />
        </li>
      </ul>
      <div>
        <header>
          <h4 class="text-lg">{{ props.block.menuSection?.title }}</h4>
        </header>
        <ul class="mb-20">
          <li
            v-for="menuItem in props.block.menuSection?.menuItems"
            :key="menuItem.id"
            class="my-4 flex items-center justify-between"
          >
            <h4 class="font-bold">{{ menuItem.title }}</h4>
            <img src="/images/icons/arrowForward.svg" class="h-5 w-5" alt="arrowForward" />
          </li>
        </ul>
        <footer v-for="item in props.block.menuItems" :key="item.id" class="mb-5 flex flex-col">
          <h4 class="text-lg font-bold">{{ item.title }}</h4>
          <div class="flex items-center gap-5">
            <img
              class="h-4 w-4"
              :src="item.link?.icon?.url"
              :alt="item.link?.icon?.alternativeText || undefined"
            />
            <a href="#" class="text-blue-500 underline">{{ item.link?.title }}</a>
          </div>
        </footer>
      </div>
    </div>

    <Transition name="fade" mode="out-in">
      <div v-if="activeItem" :key="activeItem.id" class="w-1/2">
        <BlockAccordion
          class="!m-0 !w-auto !py-0"
          :block="activeItem.accordion"
          :structured-data="false"
        />
      </div>
      <div v-else class="w-1/2">
        <BlockAccordion
          class="!m-0 !w-auto !py-0"
          :block="props.block.faqsItem[0].accordion"
          :structured-data="false"
        />
      </div>
    </Transition>
  </section>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
